import type { FaireProductEntity } from "../../entity_types/product";

export const matcha_14: FaireProductEntity = {
  token: "matcha-14",
  type: "product",
  name: "Matcha chocolate",
  brandName: "Deux Cranes",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/1b727487eadd9156be998c6961b00c87b357225699656c171f33d47ef5ec0eef.png",
  priceDollars: 3,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/1b727487eadd9156be998c6961b00c87b357225699656c171f33d47ef5ec0eef.png",
  weight: 0.3,
  dimensions: {
    width: 4,
    height: 5,
    depth: 1,
  },
  description: "Matcha-infused chocolate",
  categoryTokens: ["cat_food-snacks"],
  tags: ["matcha", "chocolate", "snack", "premium"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
